export const RESUMO_PESSOA_FISICA = [
  {
    "cpfContribuinte": "01527959872",
    "nomeContribuinte": "ZOWL KVWIVHXSR",
    "nomeMae": "ZNZYROV KVWIVHXSR",
    "situacaoCadastral": "C",
    "dataNascimento": "24091936",
    "ufResidencia": "SP",
    "municipioResidencia": "RIBEIRAO PRETO"
  }
];
